import { CoreAjaxClient } from "./CoreAjaxClient";
// Utilities
import { fetchWithTimeout } from "../utilities/ServiceUtilities";
/**
 * Basic network layer logic for executing AJAX requests using the fetch API
 * --- Provides timeout facility (requests may opt out via `disableTimeout`, e.g. keepalive fire-and-forget writes)
 * --- Provides api qos logging
 */ export class BasicAjaxClient extends CoreAjaxClient {
    /**
     * Create an instance of BasicAjaxClient
     * @param globalTimeout Fallback global timeout value in MS
     * @param loggers : Loggers for telemetry
     */ constructor(globalTimeout, loggers){
        // `disableTimeout` requests skip the client abort timer: it's a setTimeout the browser pauses on
        // hidden/frozen tabs, so it can't enforce a deadline and only mislabels slow successes as timeouts.
        const executor = (url, options)=>options.disableTimeout ? fetch(url, options) : fetchWithTimeout(url, options, this.globalTimeout);
        super(executor, loggers), this.globalTimeout = globalTimeout;
    }
}
